export const getConversoesEnergia = (state) => state.conversoesEnergia.lista
export const getIsCarregandoListaConversoesEnergia =
  (state) => state.conversoesEnergia.isCarregandoLista
